import { AdminGuardService } from './../../servicios/guards/admin-guard.service';
import { Component, ElementRef, Input, OnInit, ViewChild, OnChanges, DoCheck } from '@angular/core';
import {MatPaginatorModule, MatPaginator, MatSort, MatTableDataSource, MatDialog} from '@angular/material';

import {SelectionModel} from '@angular/cdk/collections';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";

import { AuthService } from '../../servicios/auth.service';
import { UserGuardService } from '../../servicios/guards/user-guard.service';
import { MultiUserGuardService } from '../../servicios/guards/multi-user.service';

import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
import { stringify } from '@angular/compiler/src/util';
//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';
import { environment } from "environments/environment";
import {MatRadioModule} from '@angular/material/radio';
import { GLOBALService } from "../../servicios/functions/GLOBAL.service";

export interface PeriodicElement {
  position:number;
  CODIGO: string;
  CATEGORIA: string;
  DETALLE: number;
  IMPORTE: string;
  OBSERVACIONES: string;
  FECHA_MODIFICACION: string;
}

var ELEMENT_DATA: PeriodicElement[] = [];

/**
 * @title Table with filtering
 */

@Component({
  selector: 'app-vergastos',
  templateUrl: './vergastos.component.html',
  styleUrls: ['./vergastos.component.css']
})

export class VergastosComponent implements OnInit, DoCheck  {
  result;
  @ViewChild('TABLE') table: ElementRef;

  displayedColumns: string[] = ['select','CODIGO', 'CATEGORIA', 'DETALLE', 'IMPORTE', 'ESTADO', 'OBSERVACIONES', 'FECHA_MODIFICACION'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  @ViewChild(MatSort) sort: MatSort;
  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  

  selection = new SelectionModel<PeriodicElement>(true, []);
  selectedDate;
  suma;
  codi_edit: number;
  det_edit;
  tot_edit;
  loading:boolean;
  role;
  catcat;
  estadin= "AUTORIZADO";
  estadoGasto;
  //estElegido;
  
  constructor( 
    private http: HttpClient, 
    public dialog: MatDialog,
    private global: GLOBALService,
    
    //snackbar 2
     public snackBar: MatSnackBar
     ) { 

    //this.loading=true;
    this.catcat='VIAJE';
  }
  
  ngDoCheck(){
    //asigno el valor de los option-select al local para que al volver al formulario, sigan cargados como seleccoino el usuario
    console.log("doCheck!");
    console.log(this.estadin); 
    console.log(this.catcat);

  }

  clickestado(){
    this.dataSource.data = [];
  }

  selectRow(row, detalle, imp, est) {
    this.codi_edit = row;
    this.det_edit = detalle;
    localStorage.setItem('detalleGasto', this.det_edit);
    this.tot_edit = imp;
    this.estadoGasto = est;
    //mando al local el estado para bloquear añadir gastos
    localStorage.setItem('estadoGasto', est);
    

    console.log(this.codi_edit);
    console.log(this.det_edit);
    console.log(this.estadoGasto);
  }

  loading2=false;
  autorizaGasto(){
    //http://localhost:1337/api/autorizargasto/autorizar?codgas=14&est=AUTORIZADO
    this.loading2=true;
    this.loading=true;
    this.http.get(`${environment.backendUrl}/api/autorizargasto/autorizar?codgas=${this.codi_edit}&est=AUTORIZADO`)
    .subscribe((data: any) => {
      this.result = JSON.stringify(data["affectedRows"]);
      if (this.result==1){
        console.log(`GASTO COD: ${this.codi_edit} ENVIADO A TESORERÍA!!!`);
        this.global.historicalTo("+ENVIO A TESORERIA EL GASTO COD [" + this.codi_edit +"], det: **" + this.det_edit + "** por $" + this.tot_edit+ ", a las: " + this.global.horario(),'FINALIZA-GASTO');
        //snackbar si no encuentra al usuario
        this.snackBar.open('GASTO ENVIADO A TESORERÍA!!', 'Cerrar', {duration: 4000});
        this.cargarGrid();
        this.loading=false;
        this.loading2=false;
      }else{
        console.log(`el COD: ${this.codi_edit} no existe en la bd!`)
        this.loading=false;
        this.loading2=false;
      }
  });
}


  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  //Si el número de elementos seleccionados coincide con el número total de filas..
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  //Selecciona todas las filas si no están todas seleccionadas; de lo contrario, borra la seleccion
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }
  
  addEvent(input: string, $event) {
    this.selectedDate = moment($event.value).format('YY-MM-DD');
  }

  prendeLoading(){
    this.loading=true;
  }

  ngOnInit() {
  //this.controlaRol();
    this.role=localStorage.getItem('role');
    window.scroll(0,0);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    //this.cargarGrid();
  }

/*
controlaRol(){
  //SE FIJA SI ES USER O AUTORIZANTE PARA EL CALL AL BACKEND Y SU ESTADO
  if (this.role == 'USER'){
    this.estadin='PENDIENTE';
  }
  //SI ES USER LO OBLIGA A MOSTRAR SOLO GASTOS DE VIAJE
  if (this.role == 'USER'){
    this.catcat = 'VIAJE';
  }
  
  if (this.role=='AUTORIZADOR' || this.role=='DELEGADO' || this.role=='ADMIN'){
    this.estadin='AUTORIZADO';
  }
}
*/

  cargarGrid(){
    //this.controlaRol();
    this.loading=true;
    this.http.get(`${environment.backendUrl}/api/vergastos/misgastos?id_user=${localStorage.getItem('userId')}&estado=${this.estadin}&mot=${this.catcat}`)
    .subscribe((data: any[]) => {
      this.dataSource.data = data;
      this.loading = false;  
    });
  }

  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);//converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `Gastos-${localStorage.getItem('apellidonombre')}_viaje.xlsx`);
  }

  getImporteTotal() {
    
  }

  enviarCodGasto(){
    //al hacer click en editar en el modal, envio al local storage el codigo de gasto a editar
    localStorage.setItem('codgasto_edit', `${this.codi_edit}`);  
    console.log(localStorage.getItem('codgasto_edit'));
    localStorage.setItem('imp_gasto',`${this.tot_edit}`);
  }

  eliminarGasto(){  
    this.loading=true;
    this.http.get(`${environment.backendUrl}/api/eliminargasto/eliminar?codgas=${this.codi_edit}`)
    .subscribe((data: any) => {
      this.result = JSON.stringify(data["affectedRows"]);
      if (this.result==1){
        console.log(`GASTO COD: ${this.codi_edit} ELIMINADO CORRECTAMENTE!`);
        this.global.historicalTo("-ELIMINO GASTO COD [" + this.codi_edit +"], det: **" + this.det_edit + "**, por $" + this.tot_edit+ ", a las: " + this.global.horario(),'ELIMINA-GASTO');

        //snackbar si no encuentra al usuario
        this.snackBar.open('Gasto eliminado correctamente!', 'Cerrar', {duration: 4000});

        this.cargarGrid();
        this.loading=false;
      }else{
        console.log(`el COD: ${this.codi_edit} no existe en la bd!`)
      }
    });
    
  }

  imprimirGastos(){
    localStorage.setItem('codgasto_edit', `${this.codi_edit}`);
    localStorage.setItem('imp_gasto',`${this.tot_edit}`);
    console.log("enviando al local storage.. arrayGastoPrint");
    localStorage.setItem('arrayGastoPrint', JSON.stringify(this.dataSource.data));
    //console.log(JSON.parse(localStorage.getItem('arrayGastoPrint')));
    //this.router.navigate(['/print-gastos']); 
  }

}
